import type { ReactNode } from 'react';
import { PureComponent } from 'react';

import logger from '../utils/logger';

export default class ErrorBoundary extends PureComponent<{ data?: any; children: ReactNode }> {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    const { data } = this.props;
    logger.error(error, errorInfo, data);
  }

  render() {
    const { hasError } = this.state;
    if (hasError) {
      return null;
    }

    const { children } = this.props;

    return children;
  }
}
